import { createContext, useContext } from 'react';
import { CompanyType } from '@europrocurement/l2d-modules/modules/PrescriberClient/hooks/useSirenSearch';
import { ContactFormData } from '../components/CreatePrescripteur/contactTypes';

export type Step1Data = {
    isEtrangere: boolean;
    personneType: 'morale' | 'physique';
    denomination: string;
    tvaIntracommunautaire: string;
    siren: string;
    siret: string;
    nom: string;
    prenom: string;
};

export type PortefeuilleOption = {
    id: number;
    code?: string;
    libelle?: string;
};

export type CspOption = {
    id: number;
    code?: string;
    libelle?: string;
};

export type PaysOption = {
    codeIso2?: string;
    libelle?: string;
};

export type Step2Data = {
    fullAddress: string;
    rue: string;
    adresseComplement: string;
    codePostal: string;
    ville: string;
    pays: string;
    portefeuille: PortefeuilleOption | null;
    csp: CspOption | null;
};

export type Step3Data = {
    contacts: ContactFormData[];
};

export type PrescripteurFormContextType = {
    step1: Step1Data | null;
    setStep1: (data: Step1Data) => void;
    step2: Step2Data | null;
    setStep2: (data: Step2Data) => void;
    step3: Step3Data | null;
    setStep3: (data: Step3Data) => void;
    rneData: CompanyType | null;
    setRneData: (data: CompanyType | null) => void;
    walletOptions: PortefeuilleOption[];
    cspOptions: CspOption[];
    paysOptions: PaysOption[];
    optionsLoading: boolean;
};

/* eslint-disable @typescript-eslint/no-unused-vars */
const PrescripteurFormContext = createContext<PrescripteurFormContextType>({
    step1: null,
    setStep1: (_: Step1Data) => {},
    step2: null,
    setStep2: (_: Step2Data) => {},
    step3: null,
    setStep3: (_: Step3Data) => {},
    rneData: null,
    setRneData: (_: CompanyType | null) => {},
    walletOptions: [],
    cspOptions: [],
    paysOptions: [],
    optionsLoading: false,
});
/* eslint-enable @typescript-eslint/no-unused-vars */

export const usePrescripteurForm = () => useContext(PrescripteurFormContext);

export default PrescripteurFormContext;
